import { Pipe, PipeTransform } from '@angular/core';
import { ProNumberHelper } from '@shared/classes/pro-number-helper/pro-number-helper';

@Pipe({ name: 'proNumber' })
export class ProNumberPipe implements PipeTransform {
  transform(src: any): string {
    return ProNumberHelper.getStandardizedProNbr(src);
  }
}
